import {Component, effect, inject, input, signal} from "@angular/core";
import {
  AnimalButtonComponent
} from "src/app/presentation/main-view/information-center/animals/animal-button/animal-button.component";
import {ProximitySampleStore} from "src/app/domain/samples/proximity-samples/proximity-samples.store";
import {AnimalsStore} from "src/app/domain/assets/animals/animals.store";

@Component({
  selector: 'app-animals-in-range',
  templateUrl: './animals-in-range.component.html',
  imports: [AnimalButtonComponent],
})
export class AnimalsInRangeComponent {

  animalId = input<string | undefined>(undefined);

  animalIdsInRange = signal<string[]>([]);
  loading = signal(true);

  private animalStore = inject(AnimalsStore);
  private proximitySampleStore = inject(ProximitySampleStore);

  constructor() {
    effect(() => {
      const animalId = this.animalId();
      if (!animalId) return;

      if (this.proximitySampleStore.loading()) {
        this.loading.set(true);
        return;
      }

      const deviceId = this.animalStore.animalIdToDeviceId().get(animalId);
      if (!deviceId) {
        this.animalIdsInRange.set([]);
        this.loading.set(false);
        return;
      }

      this.loading.set(true);
      const deviceIdsInRange = this.proximitySampleStore.devicesInRangePerDevice().get(deviceId) || [];

      const animalIdsInRange: string[] = [];
      for (const deviceIdInRange of deviceIdsInRange) {
        const animal = this.animalStore.deviceIdToAnimal().get(deviceIdInRange);
        if (animal) animalIdsInRange.push(animal.id);
      }

      this.animalIdsInRange.set(animalIdsInRange);
      this.loading.set(false);
    });
  }
}
